import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var changePasswordRes;
export const changePasswordTodo = createAsyncThunk('changePassword', async (data) => {
  
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'reset_password',
            data: {
                "email": data?.values?.email,
                "password": data?.values?.password,
                "confirmPassword": data?.values?.confirm_password
            },
            headers: { "Content-Type": "application/json" }
        })
        return changePasswordRes = res

    } catch (error) {
        return changePasswordRes = error.response
    }
})